import * as React from "react"
import {
  ProvisionCmsIntegration,
  ProvisionCmsIntegrationProps,
} from "./ProvisionCmsIntegration"
import { CmsVendor } from "@modules/graphql/types"
import { Button, Card, CardHeader, CardSection, Text } from "gatsby-interface"
import { MdArrowForward } from "react-icons/md"
import { cmsVendorIcons, siteTypeIcons } from "@modules/site/create/icons"

export function ProvisionCmsIntegrationCard({
  siteId,
  starterVendor,
  starterCmsTemplateId,
  starterCmsProviderFormattedName,
  onNext,
}: ProvisionCmsIntegrationProps) {
  return siteId ? (
    <ProvisionCmsIntegration
      siteId={siteId}
      starterVendor={starterVendor}
      starterCmsTemplateId={starterCmsTemplateId}
      starterCmsProviderFormattedName={starterCmsProviderFormattedName}
      onNext={onNext}
    />
  ) : (
    <InactiveCmsVendorIntegrationCard
      starterVendor={starterVendor}
      starterCmsTemplateId={starterCmsTemplateId}
      starterCmsProviderFormattedName={starterCmsProviderFormattedName}
    />
  )
}

function InactiveCmsVendorIntegrationCard({
  starterVendor,
  starterCmsTemplateId,
  starterCmsProviderFormattedName,
}: {
  starterVendor: CmsVendor
  starterCmsTemplateId?: string
  starterCmsProviderFormattedName: string
}) {
  const Icon = starterVendor
    ? cmsVendorIcons[starterVendor]
    : starterCmsTemplateId
    ? siteTypeIcons[starterCmsTemplateId]
    : null

  return (
    <Card
      css={theme => ({
        background: theme.colors.grey[5],
      })}
    >
      <CardHeader
        title="Connect Integration"
        // not ideal, but how we need to override font family to be Inter
        css={theme => ({
          h3: {
            fontFamily: theme.fonts.heading,
          },
          "& > *": { color: theme.colors.grey[50] },
        })}
      />
      <CardSection>
        <div
          css={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div css={{ display: "flex", alignItems: "center" }}>
            {Icon ? Icon : null}
            <Text
              noMarginBottom
              css={theme => ({ marginLeft: theme.space[2] })}
            >
              {starterCmsProviderFormattedName}
            </Text>
          </div>
          <Button variant="PRIMARY" disabled rightIcon={<MdArrowForward />}>
            Connect
          </Button>
        </div>
        <Text
          css={theme => ({
            color: theme.colors.grey[50],
            marginTop: theme.space[5],
          })}
        >
          Connect the CMS to automatically install the Gatsby Preview extension
          and set up Gatsby Cloud project environment variables.
        </Text>
      </CardSection>
    </Card>
  )
}
